module.exports = __webpack_public_path__ + "img/zanwushuju.be397208.png";